<div class="domain-main">
    <div class="domain-content-container">
        <div class="domain-content-left">
            <div class="domain-main-header">
                <div class="domain-main-header-title">
                    {{ 'SIGNUP_SUBSCRIBED_GOOD_NEWS' | translate }}
                    <br>
                    <span translate [translateParams]="{plan : (plan$ |async)?.name}">SIGNUP_SUBSCRIBED_TITLE</span>
                </div>
                <div class="domain-main-header-subtitle">{{ 'SIGNUP_SUBSCRIBED_SUBTITLE' | translate }}</div>
            </div>
            <div class="domain-input-container">
                <form [formGroup]="domainForm" class="form" (ngSubmit)="onSubmit()">
                    <div class="input-medium">
                        <app-smash-input placeholder="{{'SIGNUP_DOMAIN_URL' | translate }}" suffix=".{{appDomain}}"
                            [error]="submitted && f.domain.errors || (domainError$ | async) === 'DOMAIN_ALREADY_EXISTS'"
                            formControlName="domain">
                        </app-smash-input>
                    </div>
                    <div class="domain-error" *ngIf="(domainError$ | async) === 'DOMAIN_ALREADY_EXISTS'">
                        {{ 'SIGNUP_DOMAIN_DOMAIN_ALREADY_USE' | translate }}
                    </div>
                    <div class="domain-error" *ngIf="f.domain.errors && f.domain.errors.pattern">
                        {{ 'SIGNUP_DOMAIN_DOMAIN_INVALID' | translate }}
                    </div>
                </form>
            </div>
            <div class="domain-button-container">
                <button class="btn red large domain-button" type="submit" (click)="onSubmit()">{{ 'SIGNUP_DOMAIN_CREATE' | translate }}</button>
            </div>
        </div>
        <div class="domain-content-right">
            <div class="domain-content-right-wrapper-image" appElementResize>
                <div class="background-container" appBackgroundImage="../../../../assets/img/Smash_Onboarding_Domain.png"></div>
                <div class="landing-image-url-overlay">
                    <span class="label-custom-url" *ngIf="!customUrl">{{ 'SIGNUP_DOMAIN_URL' | translate }}</span>
                    <span class="label-custom-url" *ngIf="customUrl !== ''">{{customUrl}}</span>
                    <span class="label-static-url">.{{appDomain}}</span>
                </div>
            </div>
            <img>
        </div>
    </div>
</div>
